import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUpdateRequest = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 32,
	fill: "none",
	viewBox: "0 0 24 32",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M.5 1A.5.5 0 0 1 1 .5h14a.5.5 0 0 1 .354.146l8 8A.5.5 0 0 1 23.5 9v22a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5zm1 .5v29h21V9.207L14.793 1.5z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M15 .5a.5.5 0 0 1 .5.5v7.5H23a.5.5 0 0 1 0 1h-8a.5.5 0 0 1-.5-.5V1a.5.5 0 0 1 .5-.5M6.646 15.646a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L7 16.707l-1.646 1.647a.5.5 0 0 1-.708-.708zm8 2a.5.5 0 0 1 .708 0L17 19.293l1.646-1.647a.5.5 0 0 1 .708.708l-2 2a.5.5 0 0 1-.708 0l-2-2a.5.5 0 0 1 0-.708",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M12.646 13.538a4.4 4.4 0 0 0-2.755.5.5.5 0 0 1-.482-.876 5.4 5.4 0 0 1 6.447.937l.002.002a5.55 5.55 0 0 1 1.264 5.715.5.5 0 1 1-.944-.332 4.55 4.55 0 0 0-1.035-4.684 4.4 4.4 0 0 0-2.497-1.262m-5.13 2.34a.5.5 0 0 1 .306.638A4.55 4.55 0 0 0 8.857 21.2a4.4 4.4 0 0 0 5.252.762.5.5 0 1 1 .482.876 5.4 5.4 0 0 1-6.447-.937l-.002-.002a5.55 5.55 0 0 1-1.264-5.715.5.5 0 0 1 .638-.306",
			clipRule: "evenodd"
		})
	]
});
export default SvgIconUpdateRequest;
